<template>
  <layout-no-menu>
    <!-- <ion-page class="ion-page" main> -->
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-icon name="arrow-round-back" size="large" @click="$router.go(-1)"></ion-icon>
        </ion-buttons>
        <ion-title>User</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <!-- <ion-item>
          <ion-label position="stacked">Email</ion-label>
          <ion-input
            type="email"
            :value="user.email"
            @input="user.email = $event.target.value"
            readonly
          ></ion-input>
        </ion-item> -->
        <ion-item>
          <ion-label position="stacked">Display Name</ion-label>
          <ion-input :value="user.name" @input="user.name = $event.target.value" required></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Cribbage ID</ion-label>
          <ion-input type="number" :value="user.gamerId" @input="user.gamerId = $event.target.value"
            @change="gameIdChange(user.gamerId)"></ion-input>
        </ion-item>
        <ion-item>
          <div>
            <label v-for="avatar in avatars" :key="avatar.url" :for="avatar.name">
              <input :value="avatar.url" type="radio" :id="avatar.name" name="avatar" v-model="user.avatar" />
              <img style="width: 60px; height: 60px; max-width: 60px" :src="avatar.url" />
            </label>
            <template v-if="gamificationAvatar">
              <label for="gamification">
                <input :value="gamificationAvatar" type="radio" id="gamification" name="avatar" v-model="user.avatar" />
                <img style="width: 60px; height: 60px; max-width: 60px" :src="gamificationAvatar" />
              </label>
            </template>
          </div>
        </ion-item>
        <!-- <ion-item>
          <ion-label>Newsletter</ion-label>
          <ion-checkbox slot="start" :checked="user.emailSubscribe"
            @ionChange="user.emailSubscribe = $event.target.checked == true"></ion-checkbox>
        </ion-item> -->
        <ion-item>
          <ion-label position="fixed">Verified?</ion-label>
          <ion-label v-if="isVerified">true</ion-label>
          <ion-button v-if="!isVerified" v-on:click="VerifyEmail()">Verify Email</ion-button>
        </ion-item>
        <!-- <ion-item>
          <ion-label position="stacked">First Name</ion-label>
          <ion-input :value="user.firstName" @input="user.firstName = $event.target.value"></ion-input>
        </ion-item>
                 <ion-item>
          <ion-label position="stacked">Last Name</ion-label>
          <ion-input :value="user.lastName" @input="user.lastName = $event.target.value"></ion-input>
        </ion-item>-->
        <!-- <ion-item>
          <ion-label position="stacked">Password</ion-label>
          <ion-input
            type="password"
            :value="user.password"
            @input="user.password = $event.target.value"
            required
          ></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Repeat Password</ion-label>
          <ion-input
            type="password"
            :value="user.passwordVerify"
            @input="user.passwordVerify = $event.target.value"
            required
          ></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>Allow Notifications</ion-label>
          <ion-checkbox
            slot="start"
            :checked="user.allowNotifications"
            @ionChange="user.allowNotifications = $event.target.checked == true"
          ></ion-checkbox>
        </ion-item> -->
        <ion-item>
          <ion-label position="fixed">Password</ion-label>
          <ion-button v-on:click="PasswordChange()">Change Password</ion-button>
        </ion-item>
      </ion-list>

      <ion-button expand="block" v-on:click="save()">Submit</ion-button>
      <hr />
      <div style="color: red">{{ error }}</div>
    </ion-content>
    <!-- </ion-page> -->
  </layout-no-menu>
</template>
<style scoped>
div.radio img {
  border: solid 4px #bbb;
  padding: 2px;
}

div.radio label {
  font-family: arial;
}

input[type="radio"] {
  display: none;
}

input[type="radio"]:checked+img {
  border: solid 4px #ff0000;
}
</style>
<script>
import Authentication from "@/services/Authentication.js";
const authentication = new Authentication();
import Avatar from "@/services/Avatar.js";
const avatar = new Avatar();
import Gamification from "@/services/Gamification.js";
const gamification = new Gamification();
export default {
  name: "home",
  components: {},
  data() {
    var user = authentication.getUser() || {};
    let avatars = avatar.getAll();
    this.gameIdChange(user.gamerId);
    return {
      user: user,
      avatars: avatars,
      gamificationAvatar: null,
      error: "",
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    save() {
      let user = this.user;
      authentication
        .update(user)
        .then((userData) => {
          let user = userData;
          console.log("User Logged in: " + user.username, user);

          //todo: update player's avatar

          //back
          this.$router.back();
        })
        .catch((e) => {
          this.error = "Error: Save failed";
          console.warn(e);
        });
    },
    gameIdChange(gamerId) {
      if (!gamerId) return;
      gamification.GetUser(gamerId).then((userData) => {
        if (!userData) return;
        let avatar = userData.Avatar;
        if (avatar && !avatar.startsWith("http")) {
          avatar = "https://cardsjd.com/cribbage/game/" + avatar;
        }
        this.gamificationAvatar = avatar;
      });
    },
    PasswordChange() {
      this.$router.push({ path: `PasswordChange` });
    },
    VerifyEmail() {
      this.$router.push({ path: `VerifyEmail` });
    },
     async loadData() {
      //hackish way to get if user is verified.
      //the user data is pulling locally from storage.
      //we need to pull from the server to get the latest data.
      //but I dont have a endpoint to pull private data yet without proper authentication.
      const userPublic = await authentication.getUserByUserName(this.user.userName);
      this.isVerified = userPublic.verified;

     }
  },
  created() {
    this.loadData();
  },
};
</script>
